class FileType {
    public Extension: string;
    public Icon: string;
    constructor(ext: string, icon: string) {
        this.Extension = ext;
        this.Icon = icon;
    }
}
export { FileType}
